import http from "./http-common"
import {getData, postData} from "../handlers";

export default class AppServices {
    static settings = (queryString) => {
        return getData(http, `/app/settings${queryString ? `?${queryString}` : ""}`);
    }

    static localizations = (queryString) => {
        return getData(http, `/app/localizations${queryString ? `?${queryString}` : ""}`);
    }

    static menu = (menuName, queryString) => {
        return getData(http, `/app/menu/${menuName}`);
    }

    static page = (pageName, queryString) => {
        return getData(http, `/app/page/${pageName}${queryString ? `?${queryString}` : ""}`);
    }

    static request = (data) => {
        return postData(http, `/app/request/contact`, data)
    }

    static requestTemplate = (data) => {
        return postData(http, `/app/request/template`, data)
    }
}